export default function getGroupRoutedRequestInit(groupSmtp) {
    return {
        headers: {
            'X-OWA-ExplicitLogonUser': groupSmtp,
            'X-AnchorMailbox': groupSmtp,
            'X-OWA-ActionName': 'GroupMailbox',
        },
    };
}
//# sourceMappingURL=getGroupRoutedRequestInit.js.map